import { render, staticRenderFns } from "./Expired.vue?vue&type=template&id=0ac87385&"
import script from "./Expired.vue?vue&type=script&lang=ts&"
export * from "./Expired.vue?vue&type=script&lang=ts&"
import style0 from "./Expired.vue?vue&type=style&index=0&id=0ac87385&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports